import React, { useState } from 'react';
import css from './GraphExtraFilter.module.css';
import SavedSearchFilter from './SavedSearchFilter/SavedSearchFilter';
import { getTypeChildren } from '../../../../lib/search';
import { useIdentity } from '../../../../contexts/IdentityContext';

const connectionFilters = [
  {
    type: 'connections',
    children: [{ type: 'connectionsOnGraph' }, { type: 'allConnections' }],
  },
];

const CollapseIcon = ({ className, status }) => (
  <svg className={className} fill="none" viewBox="0 0 7 7" data-status={status}>
    <path d="M4 1L1 4L4 7" stroke="#131616" strokeWidth="1" />
  </svg>
);

const FilterTypeLabel = ({ label }) => {
  if (label === 'connections') {
    return (
      <span className={css.pill} data-type="Actor">
        Connections
      </span>
    );
  }
  if (label === 'connectionsOnGraph') return 'My Connections on Graph';
  if (label === 'allConnections') return 'All my Connections';
  return label;
};

const FilterType = ({ label, level, isActive = false, onClick }) => {
  return (
    <div
      data-cy="graph-filter-type"
      data-cy-name={label}
      data-level={level}
      className={css.type}
      data-status={isActive ? 'selected' : 'unselected'}
      onClick={onClick}
    >
      <p className={css.typeName}>
        <FilterTypeLabel label={label} />
      </p>
    </div>
  );
};

const FilterGroup = ({
  type,
  level,
  extraFilter,
  setExtraFilter,
  resetGraphFilter,
  setCenterId,
  centerId,
}) => {
  const hasChildren = getTypeChildren(type).length > 0;
  const { user } = useIdentity();
  const [oldCenterId, setOldCenterId] = useState(null);

  if (hasChildren) {
    return (
      <FilterCollapse
        type={type}
        level={level}
        extraFilter={extraFilter}
        setExtraFilter={setExtraFilter}
      />
    );
  }

  const handleClick = () => {
    if (type === 'allConnections') {
      setOldCenterId(centerId);
      setCenterId(user.id);
    }
    if (extraFilter === type) {
      setExtraFilter('');
      setCenterId(oldCenterId);
    } else {
      setExtraFilter(type);
    }
  };

  return (
    <FilterType
      label={type}
      level={level}
      isActive={extraFilter === type}
      onClick={handleClick}
    />
  );
};

const FilterCollapse = ({
  type,
  level,
  extraFilter,
  setExtraFilter,
  resetGraphFilter,
  setCenterId,
  centerId,
}) => {
  const [isOpen, setOpen] = useState(false);

  const isActive = extraFilter === type;

  const handleToggleClick = (event) => {
    event.stopPropagation();
    setOpen((o) => !o);
  };

  const subtypes = ['connectionsOnGraph', 'allConnections'];

  return (
    <div
      className={css.collapse}
      data-status={isActive ? 'selected' : 'unselected'}
      data-expanded={isOpen ? 'open' : 'closed'}
    >
      <div
        data-cy="graph-filter-group"
        data-cy-name={type}
        data-level={level}
        onClick={handleToggleClick}
        className={css.collapseHeader}
      >
        <div className={css.collapseContent}>
          <p className={css.collapseText}>
            <FilterTypeLabel label={type} />
          </p>
          <div className={css.collapseInfo}>
            <div
              data-cy="graph-filter-group-expand"
              className={css.collapseIcon}
              onClick={handleToggleClick}
            >
              <CollapseIcon
                className={css.collapseIconArrow}
                status={isOpen ? 'open' : 'closed'}
              />
            </div>
          </div>
        </div>
      </div>
      {isOpen && (
        <div className={css.collapseBody} data-cy="graph-filter-collapse-body">
          {subtypes.map((subtype) => (
            <FilterGroup
              key={subtype}
              type={subtype}
              level={level + 1}
              extraFilter={extraFilter}
              setExtraFilter={setExtraFilter}
              resetGraphFilter={resetGraphFilter}
              setCenterId={setCenterId}
              centerId={centerId}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const GraphExtraFilter = ({
  setGraphFilterCategory,
  setGraphFilterIndustries,
  setCenterId,
  extraFilter,
  setExtraFilter,
  resetGraphFilter,
  centerId,
}) => {
  return (
    <div data-cy="search-extra-filter" className={css.extraFilter}>
      <SavedSearchFilter
        setGraphFilterCategory={setGraphFilterCategory}
        setGraphFilterIndustries={setGraphFilterIndustries}
        setCenterId={setCenterId}
      />
      {connectionFilters.map(({ type }) => (
        <FilterCollapse
          key={type}
          type={type}
          level={0}
          extraFilter={extraFilter}
          setExtraFilter={setExtraFilter}
          resetGraphFilter={resetGraphFilter}
          setCenterId={setCenterId}
          centerId={centerId}
        />
      ))}
    </div>
  );
};

export default GraphExtraFilter;
